import * as Constants from '../../../config/Constants'
import { PopupError } from './PopupError'
import getText from '../i18n/labels'

/**
 * Mostra un popup di errore all'utente se il numero totale di soggetti superato, invitandolo ad acquistare ulteriori soggetti.
 *
 * @param {number} total - Il numero totale di soggetti.
 * @param {number} used - Il numero di soggetti utilizzati.
 * @param {string} name - Il nome dell'applicazione.
 * @param {string} [lang='it'] - La lingua del popup.
 *
 */
export function PopupSubjectLicense(props, lang = 'it') {
  const labels = getText(lang)
  const { total, used, name } = props
  return PopupError({
    text: labels.INSUFFICIENT_SUBJECTS(
      used,
      total,
      name,
      Constants.CART_LINK(0, Constants.getEcommerceSubjectProductId(name), 1)
    )
  })
}
